module.exports = __webpack_public_path__ + "static/media/10.623d21da.wav";